import { render } from "./NotFound.vue?vue&type=template&id=b39a00a0"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"

import "./NotFound.vue?vue&type=style&index=0&id=b39a00a0&lang=css"
script.render = render

export default script